import i18n from '@/plugins/i18n'

export default {
  data () {
    return {
      isCreation: false,
      radioGroup: null,
      headersQuestionTable: [
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'actions'
        },
        {
          text: i18n.t('plugin.formBuilder.questionPanel.headers.label.name'),
          align: 'left',
          value: 'label'
        },
        {
          text: i18n.t('plugin.formBuilder.questionPanel.headers.text.name'),
          align: 'left',
          value: 'text'
        }
      ]
    }
  },
  created () {
    if (this.control !== undefined) {
      this.radioGroup = this.control.value
    }
  }
}
